import { Outlet } from 'react-router-dom';

import { DashboardFavoriteModal } from './components/favorite/components/modal/dashboardFavoriteModal';
import { useDashboardViewInit } from './utils/useDashboardViewInit';

export const DashboardView = (): JSX.Element | null => {
  const { isInitialized } = useDashboardViewInit();

  if (!isInitialized) {
    return null;
  }

  return (
    <>
      <Outlet />
      <DashboardFavoriteModal />
    </>
  );
};
